export class SousTransaction{
    id : number;
    id_transaction : number;
    date : string;
    montant : any;
    type: string; 
    status : number;
    seq : any;
    send_mail : any;
}